import { useMemo } from 'react';

import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';
import { PerformanceStatusEnum } from '@/types/schema';

import { Params } from './types';

const useFeedback = (params: Params) => {
  const { performanceStatus, userContentFeedbackId } = params;
  const { [FeatureFlags.EnableFeedback]: isFeedbackEnabled } = useFeatureFlags();
  const isAdmin = useAdminRoute();

  const showFeedback = useMemo(() => {
    if (
      performanceStatus == PerformanceStatusEnum.Completed &&
      !userContentFeedbackId &&
      isFeedbackEnabled &&
      !isAdmin
    )
      return true;
    return false;
  }, [performanceStatus, userContentFeedbackId]);
  return { showFeedback };
};

export default useFeedback;
